import { createApi } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import Cookies from "js-cookie";
import getTenantId from "../../components/Tenent";

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_TARGET_API}`,
  withCredentials: true,
  headers: {
    accept: `application/json`,
  },
});

const setUpInterceptors = (getState, dispatch) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = Cookies.get("access_token");
      const refresh_token = Cookies.get("refresh_token");

      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
        config.headers["Refresh"] = `Bearer ${refresh_token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
};

const axiosBaseQuery =
  () =>
  async (
    { url, method, body, params, ...requestOpts },
    { getState, dispatch }
  ) => {
    setUpInterceptors(getState, dispatch);

    const tenantId = getTenantId();

    const enhancedHeaders = {
      ...requestOpts.headers,
      "X-Tenant-Id": tenantId,
    };

    try {
      const axiosOptions = {
        url: url,
        method,
        data: body,
        params,
        headers: enhancedHeaders,
      };

      const result = await axiosInstance(axiosOptions);
      return { data: result.data };
    } catch (axiosError) {
      let err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export const targetdashboardapi = createApi({
  reducerPath: "targetdashboardapi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["targetdashboard"],
  endpoints: (builder) => ({
    getToken: builder.mutation({
      query: () => ({
        url: `login`,
        method: "POST",
        body: {
          API_KEY: process.env.REACT_APP_ACTIVITIES_HOST_API_KEY,
        },
      }),
      invalidatesTags: ["activities"],
    }),

    Getgraphcategoriesdata: builder.query({
      query: ({ taxonomy, node, target, access_token, token }) => {
        const tenantId = getTenantId();
        return {
          url: `get_graph_coordinates`,
          method: "GET",
          headers: {
            "X-Tenant-Id": tenantId,
            Authorization: `Bearer ${token}`,
          },
          params: {
            taxonomy,
            node,
            target,
            access_token,
          },
        };
      },
      providesTags: ["targetdashboard"],
    }),

    Getgraphcategoriesdatascope1: builder.query({
      query: ({ taxonomy, node, target, access_token, token }) => {
        const tenantId = getTenantId();
        return {
          url: `get_graph_coordinates`,
          method: "GET",
          headers: {
            "X-Tenant-Id": tenantId,
            Authorization: `Bearer ${token}`,
          },
          params: {
            taxonomy,
            node,
            target,
            access_token,
          },
        };
      },
      providesTags: ["targetdashboard"],
    }),

    Getgraphcategoriesdatascope2: builder.query({
      query: ({ taxonomy, node, target, access_token, token }) => {
        const tenantId = getTenantId();
        return {
          url: `get_graph_coordinates`,
          method: "GET",
          headers: {
            "X-Tenant-Id": tenantId,
            Authorization: `Bearer ${token}`,
          },
          params: {
            taxonomy,
            node,
            target,
            access_token,
          },
        };
      },
      providesTags: ["targetdashboard"],
    }),

    Getgraphcategoriesdatascope3: builder.query({
      query: ({ taxonomy, node, target, access_token, token }) => {
        const tenantId = getTenantId();
        return {
          url: `get_graph_coordinates`,
          method: "GET",
          headers: {
            "X-Tenant-Id": tenantId,
            Authorization: `Bearer ${token}`,
          },
          params: {
            taxonomy,
            node,
            target,
            access_token,
          },
        };
      },
      providesTags: ["targetdashboard"],
    }),
  }),
});

export const {
  useGetgraphcategoriesdataQuery,
  useGetgraphcategoriesdatascope1Query,
  useGetgraphcategoriesdatascope2Query,
  useGetgraphcategoriesdatascope3Query,
  useGetTokenMutation,
} = targetdashboardapi;
